import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Draggable from "react-draggable";
import CustomAudioPlayer from "./CustomAudioPlayer";

const VoiceNotesViewModal = ({ onClose, tableData, handleDelete, hasDelete }) => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopy = type => {
        setCopySuccess(type);
        setTimeout(() => {
            setCopySuccess(false);
        }, 3500);
    };

    return (
        <div
            className="modal modal-region modal-view modal-voice-view"
            id="modalId"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel="close">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">Basic Details</div>
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr">
                            <div className="dtl-sec system-building col-md-12">
                                <div className="region-mng">
                                    <div className="tab-active location-sec recom-sec main-dtl p-0 build-dtl dtl-dy-set-outer">
                                        <div className="row m-0 mb-3">
                                            <div className="col-md-12 p-0">
                                                <div className="row">
                                                    <div className="basic-otr col-md-12 p-0">
                                                        <div className="basic-dtl-otr">
                                                            <div className="col-md-12 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>File Name</h4>
                                                                    <h3>{tableData?.name || "-"}</h3>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>Voice Note</h4>
                                                                    <h3>
                                                                        <CustomAudioPlayer src={tableData?.s3_key} duration={tableData?.duration} />
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>Narrative</h4>
                                                                    <h3>
                                                                        {tableData?.voice_text || "-"}
                                                                        <CopyToClipboard
                                                                            text={tableData?.voice_text}
                                                                            onCopy={() => handleCopy("voice")}
                                                                        >
                                                                            <div className="icon cursor-hand">
                                                                                {copySuccess === "voice" ? (
                                                                                    <>
                                                                                        <i
                                                                                            className="fa fa-check"
                                                                                            style={{ color: "green" }}
                                                                                            data-tip={"Copied to Clipboard"}
                                                                                            data-for="analyse"
                                                                                            data-place="left"
                                                                                        ></i>
                                                                                        Copied To Clipboard
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <i
                                                                                            className="fa fa-copy"
                                                                                            data-tip={"Click to Copy"}
                                                                                            data-for="analyse"
                                                                                            data-place="left"
                                                                                        ></i>
                                                                                        Copy To Clipboard
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </CopyToClipboard>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>Mobile Voice Transcript</h4>
                                                                    <h3>
                                                                        {tableData?.voice_text_mobile || "-"}
                                                                        <CopyToClipboard
                                                                            text={tableData?.voice_text_mobile}
                                                                            onCopy={() => handleCopy("mobile-voice")}
                                                                        >
                                                                            <div className="icon cursor-hand">
                                                                                {copySuccess === "mobile-voice" ? (
                                                                                    <>
                                                                                        <i
                                                                                            className="fa fa-check"
                                                                                            style={{ color: "green" }}
                                                                                            data-tip={"Copied to Clipboard"}
                                                                                            data-for="analyse"
                                                                                            data-place="left"
                                                                                        ></i>
                                                                                        Copied To Clipboard
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <i
                                                                                            className="fa fa-copy"
                                                                                            data-tip={"Click to Copy"}
                                                                                            data-for="analyse"
                                                                                            data-place="left"
                                                                                        ></i>
                                                                                        Copy To Clipboard
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </CopyToClipboard>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>Created At</h4>
                                                                    <h3>{tableData?.created_at || "-"}</h3>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 basic-box">
                                                                <div className="codeOtr">
                                                                    <h4>Updated At</h4>
                                                                    <h3>{tableData?.updated_at || "-"}</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {hasDelete && (
                                    <div className="btn-otr text-right">
                                        <button className="btn-delete-voice" type="button" onClick={() => handleDelete(tableData?.id)}>
                                            <i className="fas fa-trash-alt"></i> Delete
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default VoiceNotesViewModal;
